import React from "react";
import { useSearchParams } from "react-router-dom";

import TableFilter from "components/Shared/AppTable/TableFilter";

const AccountLedgerTableFilter = () => {
  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get("tab") || "Active";

  return (
    <TableFilter searchLabel="Payment Account">
      <div className="font-medium"> {activeTab} Account Ledger </div>
    </TableFilter>
  );
};

export default AccountLedgerTableFilter;
